/* eslint-disable @next/next/no-img-element */
import styles from './ModelViewer.module.scss'

import React from 'react'
import classnames, { Value } from 'classnames'
import '@google/model-viewer'

interface Props {
    className?: Value
    poster: string
    src?: string | null
    orientation?: string | null
}

const ModelViewer: React.FC<Props> = ({ className, poster, src, orientation }) => {
    return (
        <div className={classnames(className, styles.container)}>
            {src?.endsWith('glb') ? (
                <model-viewer
                    seamless-poster
                    src={src}
                    poster={poster}
                    camera-controls
                    camera-orbit={orientation ?? undefined}
                    auto-rotate
                    loading="lazy"
                    disable-zoom
                    interaction-prompt="basic"
                ></model-viewer>
            ) : (
                <img src={src ?? poster} alt="" />
            )}
            <div className={styles.gradient} />
        </div>
    )
}

export default ModelViewer
